<template>
    <div class="g pop-up-inner" :style="styleSet">
        <div class="md toggle-aside">
            <!-- <a title="關閉" @click.prevent="close"></a> -->
        </div>
        <mdCaption
            :caption="content.caption"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div v-html="content.html"></div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                styleSet: $styleSet
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                
                if($content.cancel){
                    $results.push($cancel);
                }

                return $results;
            },
        },
        methods: {
            action: function(){
                let $content = this.content,
                    $_action = $content.action,
                    _path = $content.path || '';

                if( this.haveAction ) {
                    $_action();
                }

                if(_path){
                    this.$router.push(_path)
                }
                this.close();
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
